// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./img/background-dixi-light-theme.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --azul-dixi: #49A8DB;
  --branco-padrao: #fff;
  --fundo-input: rgb(235, 235, 235);
  --fundo-input2: #EBEDEE;
  --fundo-input3: #F9F9F9;
  --cinza-padrao: #AFAFAF;
  --cinza-padrao2: #969696;
  --cinza-hover: #dddddd;
  --botao-hover: #3d88b1;
  --text-color: #313131;
  --text-color2:rgb(90, 90, 90);
  --text-color3: #C8C8C8;
  --cinza-em-aberto: #707070;
  --error-color: rgb(255, 56, 56);
  --vermelho-padrao: rgb(255, 56, 56);
  --botao-hover-clarinho: #d6f1ff;
  --preto-dixi: #00172b;
  --cinza-claro: #f3f3f3;
  --sucess-color: #66bb6a;
  --cinza-claro-hover: #e9e9e9;
  --aguardando-resposta-color: #FFA800;
  --aguardando-resposta-color-hover: #ee8f00;
  --finalizado-color: #46A624;
  --finalizado-color-hover: #30960b;
  --branco-interior-modais: #F9FAFA;

  --cinza-label-input-padrao: #9B9B9B;
  --cinza-fundo-input-padrao: #EBEDEE;
  --cinza-fundo-input-padrao2: #e4e6e7;
  --cinza-placeholder: #C8C8C8;

  --verde-desativado: #9FD08F;
  --texto-verde: #3B921D;

  --laranja-desativado: #FCD17D;
  --texto-laranja: #E29500;

  --vermelho-desativado: #FFC2C2;
  --texto-vermelho: #FF0000;

  --azul-desativado: #A1D1EA;
  --texto-azul: #36799D;

  --azul-fundo-comentario-proprio: #a5cde2;
  --texto-azul-comentario-proprio: #236a91;

  --cinza-desativado: #BABABA;
  --texto-cinza: #7A7A7A;

  --em-analise-color: #7B61FF;
  --em-analise-color-hover: #5a3fdc;
  --em-analise-desativado: #b3a6ff;
  --texto-em-analise: #4d3b9e;

  --congelado-color: #00B8A9;
  --congelado-color-hover: #00897b;
  --congelado-desativado: #80d8cb;
  --texto-congelado: #00695c;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Roboto', sans-serif;
}

body {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center fixed;
  min-height: 100vh;
}

.main-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  overflow-x: hidden;
}

.main-container::-webkit-scrollbar {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,iCAAiC;EACjC,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;EAC7B,sBAAsB;EACtB,0BAA0B;EAC1B,+BAA+B;EAC/B,mCAAmC;EACnC,+BAA+B;EAC/B,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,oCAAoC;EACpC,0CAA0C;EAC1C,2BAA2B;EAC3B,iCAAiC;EACjC,iCAAiC;;EAEjC,mCAAmC;EACnC,mCAAmC;EACnC,oCAAoC;EACpC,4BAA4B;;EAE5B,2BAA2B;EAC3B,sBAAsB;;EAEtB,6BAA6B;EAC7B,wBAAwB;;EAExB,8BAA8B;EAC9B,yBAAyB;;EAEzB,0BAA0B;EAC1B,qBAAqB;;EAErB,wCAAwC;EACxC,wCAAwC;;EAExC,2BAA2B;EAC3B,sBAAsB;;EAEtB,2BAA2B;EAC3B,iCAAiC;EACjC,gCAAgC;EAChC,2BAA2B;;EAE3B,0BAA0B;EAC1B,gCAAgC;EAChC,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,iFAAsF;EACtF,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\n\n:root {\n  --azul-dixi: #49A8DB;\n  --branco-padrao: #fff;\n  --fundo-input: rgb(235, 235, 235);\n  --fundo-input2: #EBEDEE;\n  --fundo-input3: #F9F9F9;\n  --cinza-padrao: #AFAFAF;\n  --cinza-padrao2: #969696;\n  --cinza-hover: #dddddd;\n  --botao-hover: #3d88b1;\n  --text-color: #313131;\n  --text-color2:rgb(90, 90, 90);\n  --text-color3: #C8C8C8;\n  --cinza-em-aberto: #707070;\n  --error-color: rgb(255, 56, 56);\n  --vermelho-padrao: rgb(255, 56, 56);\n  --botao-hover-clarinho: #d6f1ff;\n  --preto-dixi: #00172b;\n  --cinza-claro: #f3f3f3;\n  --sucess-color: #66bb6a;\n  --cinza-claro-hover: #e9e9e9;\n  --aguardando-resposta-color: #FFA800;\n  --aguardando-resposta-color-hover: #ee8f00;\n  --finalizado-color: #46A624;\n  --finalizado-color-hover: #30960b;\n  --branco-interior-modais: #F9FAFA;\n\n  --cinza-label-input-padrao: #9B9B9B;\n  --cinza-fundo-input-padrao: #EBEDEE;\n  --cinza-fundo-input-padrao2: #e4e6e7;\n  --cinza-placeholder: #C8C8C8;\n\n  --verde-desativado: #9FD08F;\n  --texto-verde: #3B921D;\n\n  --laranja-desativado: #FCD17D;\n  --texto-laranja: #E29500;\n\n  --vermelho-desativado: #FFC2C2;\n  --texto-vermelho: #FF0000;\n\n  --azul-desativado: #A1D1EA;\n  --texto-azul: #36799D;\n\n  --azul-fundo-comentario-proprio: #a5cde2;\n  --texto-azul-comentario-proprio: #236a91;\n\n  --cinza-desativado: #BABABA;\n  --texto-cinza: #7A7A7A;\n\n  --em-analise-color: #7B61FF;\n  --em-analise-color-hover: #5a3fdc;\n  --em-analise-desativado: #b3a6ff;\n  --texto-em-analise: #4d3b9e;\n\n  --congelado-color: #00B8A9;\n  --congelado-color-hover: #00897b;\n  --congelado-desativado: #80d8cb;\n  --texto-congelado: #00695c;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: 'Roboto', sans-serif;\n}\n\nbody {\n  background: url('./img/background-dixi-light-theme.png') no-repeat center center fixed;\n  min-height: 100vh;\n}\n\n.main-container {\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  overflow-x: hidden;\n}\n\n.main-container::-webkit-scrollbar {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
